import apiClient from './client'

export interface QrCodeInfo {
  found: boolean
  code: string
  status?: 'unbound' | 'active' | 'retired' | 'defective'
  is_bound?: boolean
  serial_number?: string | null
  notes?: string | null
  bound_at?: string | null
  created_at?: string | null
  message?: string
  instance?: {
    id: number
    project_id: number
    electrical_panel_id: number
    instance_number: number
    position_label: string | null
    description: string | null
    knx_address: string | null
    spec_name: string
    spec_model: string | null
    spec_manufacturer: string | null
    device_type_name: string | null
    panel_name: string | null
    project_name: string | null
  } | null
}

export interface QrHistoryItem {
  id: number
  qr_code_id: number
  device_instance_id: number
  action: 'bound' | 'unbound' | 'replaced' | 'inspected'
  user_id: number | null
  user_name?: string | null
  comment: string | null
  created_at: string
  position_label?: string | null
}

export const getQrInfo = async (code: string): Promise<QrCodeInfo> => {
  const cleanCode = code.trim().toUpperCase()
  const response = await apiClient.get(`/api/qr/${encodeURIComponent(cleanCode)}`)
  return response.data
}

export const getOrCreateQrForInstance = async (
  deviceInstanceId: number,
  notes?: string
): Promise<{ id: number; code: string; status: string; serial_number?: string | null; bound_at?: string | null }> => {
  const response = await apiClient.post('/api/qr/get-or-create', {
    device_instance_id: deviceInstanceId,
    notes,
  })
  return response.data
}

export const bindQrCode = async (params: {
  code: string
  device_instance_id: number
  serial_number?: string
  notes?: string
}): Promise<any> => {
  const response = await apiClient.post('/api/qr/bind', {
    code: params.code.trim().toUpperCase(),
    device_instance_id: params.device_instance_id,
    serial_number: params.serial_number,
    notes: params.notes,
  })
  return response.data
}

export const unbindQrCode = async (code: string): Promise<any> => {
  const response = await apiClient.post('/api/qr/unbind', {
    code: code.trim().toUpperCase(),
  })
  return response.data
}

export const getQrHistory = async (codeOrId: string | number): Promise<QrHistoryItem[]> => {
  const response = await apiClient.get(`/api/qr/history/${encodeURIComponent(codeOrId)}`)
  return Array.isArray(response.data) ? response.data : []
}

export const generateQrBatch = async (
  count: number,
  batchId?: string,
  notes?: string
): Promise<{ batch_id: string; count: number; codes: Array<{ id: number; code: string }> }> => {
  const response = await apiClient.post('/api/qr/generate-batch', {
    count,
    batch_id: batchId,
    notes,
  })
  return response.data
}
